import axios from "axios";
import label from "@/lang/StaticLabels.js";
// import alert from "@/lang/AlertMessages.js";
const taxUrl = "tax/api/v1/";

export default {
  // SaleFactorInvoice Actions (ارسال فاکتور فروش به سامانه مودیان) -------------------
  getSaleFactorInvoices({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(taxUrl + "operation/SaleFactorInvoice?" + data)
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  sendSaleFactorInvoices({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .post(taxUrl + "operation/SaleFactorInvoice/Send", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data || [];
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        commit("setLoading", { status: 0, message: "" }, { root: true });
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  inquirySaleFactorInvoices({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .post(taxUrl + "operation/SaleFactorInvoice/Inquiry", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data || [];
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        commit("setLoading", { status: 0, message: "" }, { root: true });
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Invoice Actions (صورتحساب‌های ارسال‌شده) -----------------------------------------
  // پیجینگ فلت است: totalCount و pageCount کنار isSuccess در سطح اصلی پاسخ می‌آیند
  getInvoices({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(taxUrl + "operation/Invoice?" + data)
      .then((res) => {
        commit("setInvoices", res.data.data || []);
        commit("setInvoicesTotalCount", res.data.totalCount || 0);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        commit("setInvoices", []);
        commit("setInvoicesTotalCount", 0);
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  inquiryInvoices({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .post(taxUrl + "operation/Invoice/Inquiry", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data || [];
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        commit("setLoading", { status: 0, message: "" }, { root: true });
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Excel Import Actions (ورود صورتحساب از اکسل) -----------------------------------
  importExcelInvoices({ dispatch, commit }, formData) {
    commit("setLoadingBtn", true, { root: true });
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .post(taxUrl + "operation/Invoice/ImportExcel", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data && res.data.isSuccess === false) {
          if (res.data.message) {
            commit("setError", res.data.message, { root: true });
          }
          return null;
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data || [];
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        if (
          error.code === "ECONNABORTED" ||
          status === 408 ||
          status === 504 ||
          (!error.response && error.request)
        ) {
          commit("setError", label.caption.taxImportExcelTimeout, {
            root: true,
          });
        } else {
          dispatch("errorPOSTHandler", error, { root: true });
        }
        return null;
      })
      .finally(() => {
        commit("setLoading", { status: 0, message: "" }, { root: true });
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Key Actions (کلیدهای سامانه مودیان) ---------------------------------------------
  // فقط کلیدهای شعبه جاری برمی‌گردند؛ شعبه از هدر خوانده می‌شود و فرانت آن را نمی‌فرستد
  getKeys({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(taxUrl + "basic/Key?" + data)
      .then((res) => {
        commit("setKeys", res.data.data || []);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        commit("setKeys", []);
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // کلید شخص حقوقی
  createKey({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(taxUrl + "basic/Key", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data || null;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // کلید شخص حقیقی
  createNonLegalKey({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(taxUrl + "basic/Key/CreateNonLegal", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data || null;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
